import { ComponentType } from 'react';
import { RolesEnum } from '../../externals/VerifyRole';
import { VideoEventsRoute } from '../components/VideoEventsRoute';
import VideoRecallRoute from '../components/VideoRecallRoute';
import { DeviceAssociation } from '$Pages/DeviceAssociation/DeviceAssociation';
import { Installers } from '$Pages/Installers/Installers';
import { Settings } from '$Pages/Settings/Settings';
import { VideoDashboardPage } from '$Pages/VideoDashboard/VideoDashboard';
import { GeotabConfiguration } from '$Pages/GeotabConfiguration/GeotabConfiguration';
import { InvalidRoute } from '$Pages/InvalidRoute/InvalidRoute';
import { Error } from '$Pages/Error/Error';
import { Login } from '$Pages/Login/Login';
import { LoginResponse } from '../../oauth/LoginResponse';
import { LogoutResponse } from 'oauth/LogoutResponse';

export interface StandardRouteConfig {
    path: string;
    label: string;
    Component: ComponentType;
    allowedRoles?: RolesEnum[];
}

export enum StandardProtectedRoutePaths {
    Home = '/',
    VideoEvents = '/videoevents',
    VideoRecall = '/videorecall',
    DeviceAssociation = '/deviceassociation',
    Installers = '/installers',
    Settings = '/settings',
    VideoDashboard = '/videodashboard',
    GeotabConfiguration = '/geotabaddinconfiguration',
    CatchAll = '*',
}

export enum StandardPublicRoutePaths {
    Error = '/error',
    Login = '/login',
    LoginResponse = '/loginResponse',
    LogoutResponse = '/logoutResponse',
}

export const standardProtectedRouteConfig: StandardRouteConfig[] = [
    {
        path: StandardProtectedRoutePaths.Home,
        label: 'Video Events',
        Component: VideoEventsRoute,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.VideoEvents,
        label: 'Video Events',
        Component: VideoEventsRoute,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.VideoRecall,
        label: 'Video Recall',
        Component: VideoRecallRoute,
        allowedRoles: [RolesEnum.videoRecallEdit, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.DeviceAssociation,
        label: 'Device Association',
        Component: DeviceAssociation,
        allowedRoles: [RolesEnum.videoAdmin, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.Installers,
        label: 'Installers',
        Component: Installers,
        allowedRoles: [RolesEnum.videoAdmin, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.Settings,
        label: 'Settings',
        Component: Settings,
        allowedRoles: [RolesEnum.videoAdmin, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.VideoDashboard,
        label: 'Video Dashboard',
        Component: VideoDashboardPage,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit, RolesEnum.encompassVideo],
    },
    {
        path: StandardProtectedRoutePaths.GeotabConfiguration,
        label: 'Geotab Addin Configuration',
        Component: GeotabConfiguration,
    },
    {
        path: StandardProtectedRoutePaths.CatchAll,
        label: 'Invalid Route',
        Component: InvalidRoute,
    },
];

export const standardPublicRouteConfig: StandardRouteConfig[] = [
    {
        path: StandardPublicRoutePaths.Error,
        label: 'Error',
        Component: Error,
    },
    {
        path: StandardPublicRoutePaths.Login,
        label: 'Login',
        Component: Login,
    },
    {
        path: StandardPublicRoutePaths.LoginResponse,
        label: 'Login Response',
        Component: LoginResponse,
    },
    {
        path: StandardPublicRoutePaths.LogoutResponse,
        label: 'Logout Response',
        Component: LogoutResponse,
    },
];
